module.exports = __webpack_public_path__ + "components/flag/static/square/il-4ccf9a0db0ed89ef089466c9a4020213.svg";